import Request from 'core/gd/data/request';
import DatetimeUtils from "core/gd/utils/datetime-utils";

export default class ApiReminder {

    create(reminderType, title, scheduleStatus, scheduleDate, scheduleMoment, descriptionTxt, descriptionRtf) {
        // "title":             "Reminder 1",
        // "scheduleStatus":    1,
        // "scheduleDate":      "2021-05-10",
        // "descriptionTxt":    "Test reminder"
        // "descriptionRtf":    {}

        const request = new Request(this, 'POST', 'new-reminder', {
            reminderType,
            title,
            scheduleStatus,
            scheduleDate:   scheduleDate instanceof Moment ? DatetimeUtils.momentToDate(scheduleDate) : scheduleDate,
            scheduleMoment: scheduleMoment instanceof Moment ? DatetimeUtils.momentToUTCISODatetime(scheduleMoment) : scheduleMoment,
            descriptionTxt,
            descriptionRtf
        });

        request.done(response=>{
            gd.growl.reminderCreated(response.id, response.title);
        })

        return request;
    }

    get(reminderId) {
        return new Request(this, 'GET', 'reminder/{0}'.f(reminderId), {}, true, false);
    }

    delete(reminderId) {
        return new Request(this, 'DELETE', 'reminder/{0}'.f(reminderId), {});
    }

    update(reminderId, data) {
        const params = _.assign({}, data);
        if (data.scheduleDate)      params.scheduleDate = data.scheduleDate instanceof Moment ? DatetimeUtils.momentToDate(data.scheduleDate) : data.scheduleDate;
        if (data.scheduleMoment)    params.scheduleMoment = data.scheduleMoment instanceof Moment ? DatetimeUtils.momentToUTCISODatetime(data.scheduleMoment) : data.scheduleMoment;

        return new Request(this, 'PUT', 'reminder/{0}'.f(reminderId), params);
    }
}